var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 0H7.03125C3.148 0 0 3.148 0 7.03125V22.9688C0 26.852 3.148 30 7.03125 30H22.9688C26.852 30 30 26.852 30 22.9688V7.03125C30 3.148 26.852 0 22.9688 0Z",
    fill: "url(#paint0_radial_13_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 0H7.03125C3.148 0 0 3.148 0 7.03125V22.9688C0 26.852 3.148 30 7.03125 30H22.9688C26.852 30 30 26.852 30 22.9688V7.03125C30 3.148 26.852 0 22.9688 0Z",
    fill: "url(#paint1_radial_13_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0011 3.28125C11.8185 3.28125 11.419 3.2952 10.1691 3.35203C8.92148 3.40922 8.06988 3.60668 7.3248 3.89648C6.55395 4.19578 5.90016 4.59621 5.24883 5.24777C4.59691 5.89922 4.19648 6.55301 3.89625 7.32352C3.60563 8.06883 3.40793 8.92078 3.3518 10.1678C3.2959 11.4178 3.28125 11.8174 3.28125 15.0001C3.28125 18.1828 3.29531 18.581 3.35203 19.8309C3.40945 21.0785 3.60691 21.9301 3.89648 22.6752C4.19602 23.4461 4.59645 24.0998 5.24801 24.7512C5.89922 25.4031 6.55301 25.8045 7.32328 26.1037C8.06895 26.3936 8.92066 26.591 10.168 26.6482C11.418 26.705 11.8172 26.719 14.9996 26.719C18.1826 26.719 18.5808 26.705 19.8307 26.6482C21.0783 26.591 21.9308 26.3936 22.6765 26.1037C23.447 25.8045 24.0998 25.4031 24.7509 24.7512C25.4029 24.0998 25.8032 23.4461 26.1035 22.6755C26.3916 21.9301 26.5894 21.0783 26.648 19.8312C26.7041 18.5812 26.7188 18.1828 26.7188 15.0001C26.7188 11.8174 26.7041 11.418 26.648 10.168C26.5894 8.92043 26.3916 8.06895 26.1035 7.32387C25.8032 6.55301 25.4029 5.89922 24.7509 5.24777C24.0991 4.59598 23.4472 4.19555 22.6758 3.8966C21.9287 3.60668 21.0766 3.4091 19.8291 3.35203C18.579 3.2952 18.1811 3.28125 14.9974 3.28125H15.0011ZM13.9498 5.39309C14.2618 5.39262 14.61 5.39309 15.0011 5.39309C18.1301 5.39309 18.5009 5.40434 19.7365 5.46047C20.8791 5.51273 21.4992 5.70363 21.9123 5.86406C22.4592 6.07641 22.8491 6.33035 23.259 6.74062C23.6692 7.15078 23.923 7.54137 24.1359 8.08828C24.2964 8.50078 24.4875 9.12094 24.5395 10.2635C24.5957 11.4989 24.6079 11.8699 24.6079 14.9974C24.6079 18.1249 24.5957 18.4961 24.5395 19.7313C24.4873 20.8739 24.2964 21.4941 24.1359 21.9067C23.9236 22.4536 23.6692 22.843 23.259 23.2529C22.8489 23.6631 22.4595 23.9169 21.9123 24.1294C21.4997 24.2905 20.8791 24.4809 19.7365 24.5332C18.5011 24.5893 18.1301 24.6015 15.0011 24.6015C11.8719 24.6015 11.501 24.5893 10.2657 24.5332C9.12316 24.4805 8.50301 24.2896 8.08957 24.1291C7.54277 23.9167 7.15207 23.6629 6.74191 23.2527C6.33176 22.8425 6.07793 22.4529 5.865 21.9057C5.70457 21.4931 5.51344 20.873 5.46141 19.7304C5.40527 18.495 5.39402 18.124 5.39402 14.9945C5.39402 11.865 5.40527 11.496 5.46141 10.2606C5.51367 9.11801 5.70457 8.49785 5.865 8.08477C6.07746 7.53785 6.33176 7.14727 6.74203 6.73711C7.1523 6.32695 7.54277 6.07301 8.08969 5.8602C8.50277 5.69906 9.12316 5.50863 10.2657 5.45613C11.3468 5.40727 11.7657 5.39262 13.9498 5.39016V5.39309ZM21.2565 7.33887C20.4802 7.33887 19.8503 7.96816 19.8503 8.74465C19.8503 9.52102 20.4802 10.1509 21.2565 10.1509C22.0329 10.1509 22.6628 9.52102 22.6628 8.74465C22.6628 7.96828 22.0329 7.3384 21.2565 7.3384V7.33887ZM15.0011 8.98195C11.6776 8.98195 8.98301 11.6766 8.98301 15.0001C8.98301 18.3237 11.6776 21.017 15.0011 21.017C18.3246 21.017 21.0183 18.3237 21.0183 15.0001C21.0183 11.6767 18.3244 8.98195 15.0008 8.98195H15.0011ZM15.0011 11.0938C17.1584 11.0938 18.9074 12.8426 18.9074 15.0001C18.9074 17.1574 17.1584 18.9064 15.0011 18.9064C12.8438 18.9064 11.0948 17.1574 11.0948 15.0001C11.0948 12.8426 12.8436 11.0938 15.0011 11.0938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.96875 32.3106) rotate(-90) scale(29.7322 27.6533)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.02512 2.16105) rotate(78.681) scale(13.2905 54.7837)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d6f66dab2107d721722d44b1d5f3ea45.svg";
export { ForwardRef as ReactComponent };